import { Instagram, Mail, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#26221F] px-6 pb-10 pt-4 text-[#FAF7F2] lg:px-12" data-testid="footer">
      <div className="mx-auto max-w-7xl border-t border-[#FAF7F2]/15 pt-12">
        <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/logo-mark.jpeg"
                alt="Her Label logo"
                className="h-10 w-10 rounded-xl object-cover"
              />
              <span className="font-display text-lg tracking-[0.22em]">HER LABEL</span>
            </div>
            <p className="mt-4 max-w-xs font-display text-lg italic text-[#FAF7F2]/60">
              a label of her own
            </p>
          </div>
          <div className="flex flex-col gap-4 text-sm text-[#FAF7F2]/70">
            <a
              href="https://instagram.com/herlabel.in"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 transition-colors duration-300 hover:text-[#D8AFA4]"
              data-testid="footer-instagram"
            >
              <Instagram className="h-4 w-4" /> @herlabel.in
            </a>
            <a
              href="mailto:hello@herlabel.in"
              className="flex items-center gap-3 transition-colors duration-300 hover:text-[#D8AFA4]"
              data-testid="footer-email"
            >
              <Mail className="h-4 w-4" /> hello@herlabel.in
            </a>
            <span className="flex items-center gap-3" data-testid="footer-domain">
              <Globe className="h-4 w-4" /> www.herlabel.in
            </span>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-2 border-t border-[#FAF7F2]/10 pt-6 text-[10px] font-semibold uppercase tracking-[0.3em] text-[#FAF7F2]/35 md:flex-row md:justify-between">
          <span>© 2026 Her Label. All rights reserved.</span>
          <span>Luxury press-on couture — launching soon</span>
        </div>
      </div>
    </footer>
  );
}
